import "./LockingPeriodSelect.scss"
import { Box } from "@mui/material"
import classNames from "classnames"
import React from "react"
import Text from "src/components/Text"
import { BoostPoolInfo } from "src/constants/boostPools"
import { formatLockPeriod } from "src/pages/Stake/helpers"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import { useVaultsApr } from "../../../hooks/useVaultsApr"
import GradientWrapper from "src/components/GradientWrapper"

interface LockingPeriodSelectProps extends BoostPoolInfo {
  isSelected: boolean
  onSelect: () => void
}

const LockingPeriodSelect = ({
  imgSrc,
  lockPeriod,
  isSelected,
  onSelect,
  pid,
}: LockingPeriodSelectProps) => {
  const vaultsApr = useVaultsApr()
  const poolApr = vaultsApr.find((pool) => pool.poolId === pid)?.apr || "0"

  return (
    <GradientWrapper
      borderRadius="10px"
      className={classNames("locking-period-select", {
        selected: isSelected,
      })}
      background="#000000"
    >
      <Box onClick={onSelect} py={2}>
        <img src={imgSrc} />
        <Box>
          <Text bold>{formatLockPeriod(lockPeriod)}</Text>
          <Text size="small" color="primary.main" mt={0.5}>
            APR: {formatNumber(poolApr, 2, 2)}%
          </Text>
        </Box>
      </Box>
    </GradientWrapper>
  )
}

export default LockingPeriodSelect
